export const menu = [
  {
    icon: 'bx bx-user-circle',
    title: 'Merchant',
    accId: 0,
    href: '/merchant',
    permission:'',
    type: 'MC'
  },
  {
    icon: 'bx bx-notepad',
    title: 'Hợp đồng',
    accId: 1,
    href: '/contract',
    permission:'',
    type: 'CONTRACT'
  },
    {
    icon: 'bx bx-user-circle',
    title: 'Giới thiệu Merchant',
    accId: 0,
    href: '/merchant',
    permission: 'CNPS_AGENT_PARTNER_BANK_DIGITAL',
    type: 'AGENT_BANK'
  },
  {
    icon: 'bx bx-notepad',
    title: 'Hợp đồng MC giới thiệu',
    accId: 1,
    href: '/contract',
    permission: 'CNPS_AGENT_PARTNER_BANK_DIGITAL',
    type: 'AGENT_BANK'
  },
  {
    icon: 'bx bx-user-circle',
    title: 'Quản lý tài khoản',
    accId: 2,
    href: '/agent-bank',
    permission: '',
    type: 'AGENT_BANK'
  },
  {
    icon: 'bx bxs-devices',
    title: 'Quản lý thiết bị',
    accId: 2,
    href: '/list-device',
    permission: '',
    type: 'AGENT_BANK'
  },
  {
    icon: 'bx bx-file-blank',
    title: 'Quản lý giao / nhận',
    accId: 2,
    href: '/transfer-device',
    permission: '',
    type: 'AGENT_BANK'
  },
  {
    icon: 'bx bxs-report',
    title: 'Báo cáo TB thanh toán',
    accId: 2,
    href: '/partner-reporting',
    permission: '',
    type: 'AGENT_BANK'
  },
    {
    icon: 'bx bx-credit-card-alt',
    title: 'Quản lý đặt hàng',
    accId: 2,
    href: '/order-form',
    permission: 'CNPS_DEVICE_PURCHASE_ORDER_VIEW',
    type: 'AGENT_BANK'
  },
  {
    icon: 'bx bx-box',
    title: 'Yêu cầu combo bán hàng',
    accId: 2,
    href: '/sales-combos',
    permission: 'CNPS_AGENT_COMBO_REGISTRATION_REQUEST_VIEW',
    type: 'AGENT_BANK'
  },
  // {
  //   icon: 'bx bx-cog',
  //   title: 'Cài đặt',
  //   accId: 11,
  //   listPermission: ['CNPS_CFG_ROLE_LIST'],
  //   child: [
  //     {
  //       title: 'Quyền',
  //       href: '/role',
  //       permission: 'CNPS_CFG_ROLE_LIST'
  //     },
  //     {
  //       title: 'Cấu hình Gói dịch vụ/ Thiết bị',
  //       href: '/device-service-price-config',
  //       permission: ''
  //     }
  //   ]
  // },
]
